<ng-container [ngSwitch]="view">
  <ng-container *ngSwitchCase="viewModes.create">
    <ng-container *ngTemplateOutlet="createQuestionsViewTemplate"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="viewModes.edit">
    <ng-container *ngTemplateOutlet="editQuestionViewTemplate"></ng-container>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <ng-container *ngTemplateOutlet="questionsViewTemplate"></ng-container>
  </ng-container>
</ng-container>

<!-- Questions view template -->
<ng-template #questionsViewTemplate>
  <div class="tutorization--block__column margin-top">
    <div *ngIf="stats" class="tutorization--block__row">
      <div class="tutorization--block__item">
        <div class="dashboard-card-item">
          <div class="dashboard-card-item-title text-centered">
            {{ 'questions.widgets.rightAnswersPercentage' | translate }}
          </div>
          <div class="dashboard-card-item-text text-centered">{{ stats.percentage | percent }}</div>
        </div>
      </div>

      <div class="tutorization--block__item">
        <div class="dashboard-card-item">
          <div class="dashboard-card-item-title text-centered">
            {{ 'questions.widgets.ratioAnswersPerQuestion' | translate }}
          </div>
          <div class="dashboard-card-item-text text-centered">{{ stats.ratioAnswers | number : '1.2-2' }}</div>
        </div>
      </div>

      <div class="tutorization--block__item">
        <div class="dashboard-card-item">
          <div class="dashboard-card-item-title text-centered">
            {{ 'questions.widgets.totalQuestionsCreated' | translate }}
          </div>
          <div class="dashboard-card-item-text text-centered">{{ stats.totalQuestionCreated }}</div>
        </div>
      </div>
    </div>
  </div>

  <lms-toolbar [options]="toolbarConfig">
    <div class="lms-toolbar__item" *lmsProfileGuard="'mars.questions.create'">
      <gl-button
        color-primary
        [text]="'actions.createQuestionsList' | translate"
        (onClick)="changeView(viewModes.create)"
        title="{{ 'questions.create' | translate }}"
        [disabled]="createQuestionsDisabled"
      >
      </gl-button>
    </div>
  </lms-toolbar>

  <div class="gl-table__container">
    <gl-table
      [id]="listId"
      [dataSource]="dataSource"
      data-testid="marsTutorizationQuestionsTable"
      [placeholder]="'actions.noResultTable' | translate"
      paginator
    >
    </gl-table>
  </div>
</ng-template>

<!-- create questions template -->
<ng-template #createQuestionsViewTemplate>
  <lms-mars-questions-create
    [groupId]="group.id"
    (created)="onQuestionsCreated($event)"
    (cancel)="changeView(viewModes.questions)"
  ></lms-mars-questions-create>
</ng-template>

<!-- edit question template -->
<ng-template #editQuestionViewTemplate>
  <lms-mars-question-editor [question]="selectedQuestion" (onSave)="onUpdateQuestion()">
    <gl-button
      color-secondary
      [text]="'actions.cancel' | translate"
      (onClick)="editQuestion()"
      form-actions-before
      title="{{ 'actions.cancel' | translate }}"
    ></gl-button>
  </lms-mars-question-editor>
</ng-template>
